module.exports = __webpack_public_path__ + "assets/overview.0e446745.svg";